import { LabelTextProps } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import FormRow from 'modules/core/components/FormRow'
import Country from 'modules/core/components/Inputs/Country'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

export const ADDRESS_ROW_TYPES = {
  address: 'address',
  city: 'city',
  state: 'state',
} as const

export type ScrollRowType = keyof typeof ADDRESS_ROW_TYPES

export const isScrollAddressRowType = (value: string): value is ScrollRowType =>
  value in ADDRESS_ROW_TYPES

interface Props {
  mandatory?: boolean
  secondaryLabel?: LabelTextProps['secondaryLabel']
  form: Form
  readonly?: boolean
  scrollTo?: ScrollRowType | null | undefined
}

const AddressInput = ({
  mandatory,
  secondaryLabel,
  form,
  readonly = false,
  scrollTo = null,
}: Props) => {
  const optionalPlaceholder = i18n.t('common.optional')
  const shouldScrollTo = (type: ScrollRowType | null | undefined) => scrollTo === type

  return (
    <>
      <FormRow scrollToRow={shouldScrollTo('address')}>
        <Text
          mandatory={mandatory}
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.address_line_1')}
          field={form.get('address_line_1')}
          readonly={readonly}
        />
      </FormRow>
      <FormRow>
        <Text
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.address_line_2')}
          field={form.get('address_line_2')}
          readonly={readonly}
          placeholder={optionalPlaceholder}
        />
      </FormRow>
      <FormRow multi scrollToRow={shouldScrollTo('city')}>
        <Text
          mandatory={mandatory}
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.city')}
          field={form.get('city')}
          readonly={readonly}
        />
        <Text
          mandatory={mandatory}
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.zip')}
          field={form.get('postal_code')}
          readonly={readonly}
        />
      </FormRow>
      <FormRow scrollToRow={shouldScrollTo('state')}>
        <Text
          mandatory={mandatory}
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.state')}
          field={form.get('state')}
          readonly={readonly}
        />
      </FormRow>
      <FormRow>
        <Country
          mandatory={mandatory}
          secondaryLabel={secondaryLabel}
          label={i18n.t('address_input.country')}
          field={form.get('country')}
          value="Spain"
          readonly={readonly}
        />
      </FormRow>
    </>
  )
}

export default AddressInput
